import { WINDOW } from "../constants/environment"
import { constant } from "utils";

export default class cookieHandler {
  constructor() {
    if (!WINDOW) return
    this.cookie = WINDOW.document.cookie || ""
    this.parsedCookie = this._parseCookie()
  }

  _parseCookie(){
    let parsedCookie = {}
    let decodedCookie = this.cookie
    let decodedCookieArray = decodedCookie.split(";")
    decodedCookieArray.forEach(item => {
      let splitedItem = item.split("=")
      parsedCookie[splitedItem[0].trim()] = splitedItem[1]
    })
    this.parsedCookie = parsedCookie
    return parsedCookie
  }


  getCookie(name) {
    let nameFormatted = name
    if (this.parsedCookie && this.parsedCookie[nameFormatted]){
      return this.parsedCookie[nameFormatted]
    }
    return null
  }


  setCookie(name,value){
    let newCookie = `${name}=${value};`

    const date = new Date();
    const days = 30;
    date.setTime(date.getTime()+(days*24*60*60*1000));
    newCookie = `${newCookie};path=/;expires=${date.toGMTString()}`

    WINDOW.document.cookie = newCookie
    this.cookie = WINDOW.document.cookie
    this.parsedCookie = this._parseCookie()
    return newCookie
  }

}




// WEBPACK FOOTER //
// ./src/AtomicUtils/cookieHandler.js